export default __webpack_public_path__ + "static/media/bolivia_flag.61393233.svg";